
import { useTranslation } from 'react-i18next';

const BenefitsSection = () => {
  const { t } = useTranslation('partnership');

  const benefits = [
    { icon: 'ri-percent-line', title: t('benefits.items.0.title'), description: t('benefits.items.0.description') },
    { icon: 'ri-megaphone-line', title: t('benefits.items.4.title'), description: t('benefits.items.4.description') },
    { icon: 'ri-graduation-cap-line', title: t('benefits.items.3.title'), description: t('benefits.items.3.description') },
    { icon: 'ri-store-3-line', title: t('benefits.items.2.title'), description: t('benefits.items.2.description') },
    { icon: 'ri-shield-check-line', title: t('benefits.items.1.title'), description: t('benefits.items.1.description') },
    { icon: 'ri-star-line', title: t('benefits.items.5.title'), description: t('benefits.items.5.description') },
  ];

  return (
    <section id="benefits" className="py-8 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 md:mb-16">
          <span className="text-gold-600 font-semibold text-[10px] md:text-sm uppercase tracking-wider">{t('benefits.badge')}</span>
          <h2 className="text-lg md:text-3xl lg:text-4xl font-bold text-gray-900 mt-2 md:mt-3 mb-2 md:mb-4 font-serif">
            {t('benefits.title')}
          </h2>
          <p className="text-xs md:text-base text-gray-600 max-w-2xl mx-auto">
            {t('benefits.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-xl md:rounded-2xl p-3 md:p-8 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 group"
            >
              <div className="w-8 h-8 md:w-14 md:h-14 flex items-center justify-center bg-gradient-to-br from-gold-400 to-gold-600 rounded-lg md:rounded-xl mb-2 md:mb-5 group-hover:scale-110 transition-transform duration-300">
                <i className={`${benefit.icon} text-sm md:text-2xl text-white`}></i>
              </div>
              <h3 className="text-xs md:text-lg font-bold text-gray-900 mb-1 md:mb-3">{benefit.title}</h3>
              <p className="text-[10px] md:text-sm text-gray-600 leading-relaxed line-clamp-4 md:line-clamp-none">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
